import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { selectedAudioState, selectedVideoState } from '../customStorageSettings/actions';
StateListenerRegistry.register(
/* selector */ (state) => state['features/base/media'].audio.muted, 
/* listener */ (muted, { dispatch, getState }, previousMuted) => {
    if (typeof previousMuted === 'undefined') {
        return;
    }
    const state = getState();
    const { startWithAudioMutedWildix } = state['wildix/customStorageSettings'];
    if (muted !== startWithAudioMutedWildix) {
        dispatch(selectedAudioState(muted));
    }
});
StateListenerRegistry.register(
/* selector */ (state) => state['features/base/media'].video.muted, 
/* listener */ (muted, { dispatch, getState }, previousMuted) => {
    if (typeof previousMuted === 'undefined') {
        return;
    }
    const state = getState();
    const isVideoMuted = Boolean(muted);
    const { startWithVideoMutedWildix } = state['wildix/customStorageSettings'];
    const { hovered } = state['features/toolbox'];
    if (isVideoMuted !== startWithVideoMutedWildix && hovered) {
        dispatch(selectedVideoState(isVideoMuted));
    }
});
